<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-01-15 13:10:00
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\StaffCard\StaffCard.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-07 14:41:51
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_StaffCard_list_title')"
    pad="0"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
  >
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(filter);
        "
        @update="
          (prop, value, selected) => {
            if (prop == 'department') curDept = value; //触发岗位更新下拉
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <v-card class="transparent d-flex flex-row rounded-lg" elevation="0">
        <!-- left -->
        <v-card
          class="fill-height white rounded-lg pa-0"
          elevation="0"
          width="280"
          :style="{
            minHeight: $vuetify.breakpoint.height - 238 + 42 - 48 + 'px',
          }"
        >
          <!-- choose -->
          <noContent v-if="allStaff.length == 0 && !staff_Loading" />
          <v-sheet
            v-if="staff_Loading"
            :style="{
              minHeight: $vuetify.breakpoint.height - 238 + 42 - 48 + 'px',
            }"
            class="text-center d-flex align-center justify-center"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              size="30"
              width="2"
            ></v-progress-circular>
          </v-sheet>
          <v-list
            dense
            v-if="!staff_Loading"
            :style="{
              maxHeight: $vuetify.breakpoint.height - 238 + 42 - 48 + 'px',
            }"
            class="scroll_content_y"
          >
            <v-list-item-group v-model="selectOneStaff" color="primary">
              <v-list-item
                v-for="(staff, index) in show_Staff"
                :key="`staff---${index}`"
                dense
                two-line
                :value="staff.staff_uuid"
                class="pa-0 px-2 ma-0"
              >
                <v-list-item-avatar size="36" class="pa-0 ma-0 mr-2">
                  <StaffAvatar
                    size="36"
                    :isTemp="staff.is_temp"
                    :src="staff.staff_avatar"
                    :staff_name="staff.preferred_name"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">
                    {{ $getCommonLangValue(staff.preferred_name) }}
                    <span class="text--secondary text-caption-xs">{{
                      staff.staff_code
                    }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-body-2">
                    {{ $getCommonLangValue(staff.job_post_name) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
        <!-- left -->
        <v-card
          class="ml-3 rounded-lg flex-grow-1"
          elevation="0"
          :style="{
            maxWidth: 'calc(100% - 292px)',
          }"
        >
          <Tabler
            :headers="headers"
            :items="desserts"
            content-class="px-4 py-0"
            :showSelect="showSelect"
            :height="$vuetify.breakpoint.height - 275 - 48 - 28"
          >
            <template v-slot:top>
              <v-sheet
                v-if="selectOneStaff"
                class="d-flex justify-end align-center"
                height="40"
              >
                <v-btn
                  text
                  small
                  class="text-capitalize text-body-2"
                  color="primary"
                  v-if="hasBtn('edit-admin-staff-card')"
                  :ripple="false"
                  @click="toEdit(selectItem, 'edit')"
                >
                  {{ $t("label_essweb_StaffCard_dialog_editCardBtnLabel") }}
                  <span class="material-icons-round md-18">edit</span>
                </v-btn>
              </v-sheet>
              <v-divider v-if="selectOneStaff"></v-divider>
            </template>
            <template v-slot:item.code="{ item }">
              <div class="text--primary">
                {{ item.staff_card_code }}
              </div>
            </template>
            <template v-slot:item.startDate="{ item }">
              <div class="text--primary">
                {{ $getDateTime(item.effective_utc_start_date, "YYYY-MM-DD") }}
              </div>
            </template>
          </Tabler>
        </v-card>
      </v-card>
    </template>
    <!-- content -->
    <template v-slot:page-actions></template>
    <!-- tools -->
    <template v-slot:tools-main>
      <editStaffCard
        :show="showEdit"
        @close="
          showEdit = false;
          curUuid = null;
          curName = '';
        "
        :curName="curName"
        :triger="triger"
        @save="onSave"
        :curUuid="curUuid"
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>

<script>
import editStaffCard from "@/Page/EssAdmin/Attendance/StaffCard/components/editStaffCard";
export default {
  name: "StaffCard",
  components: { editStaffCard },
  computed: {},
  data() {
    return {
      staff_Loading: false,
      allStaff: [],
      show_Staff: [],
      selectOneStaff: null,
      selectWillStaff: null,
      curUuid: null,
      triger: "edit",
      totalCount: 0,
      showEdit: false,
      headers: [
        {
          text: "label_essweb_StaffCard_dialog_cardCodeLabel",
          value: "code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_StaffCard_dialog_startDateLabel",
          value: "startDate",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      curName: "",
      selectItem: null,
      showSelect: false,
      filterPageData: null,
      curDept: [],
      filterObjects: [
        {
          type: "select",
          sequence: 0,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "staff",
          avatar: true,
          twoLine: true,
          multiple: true,
          label: "label_essweb_attendanceRecord_list_staffLabel",
          value: [],
          selected: [],
          data: {
            api: "/staff-card/get-list/",
            url_type: "staff",
            args: null,
            table: "ess_punch_map_staff_punch_card_number",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "org_level_name",
          name: "department",
          multiple: true,
          label: "label_essweb_UM_filters_departmentLabel",
          value: [],
          selected: [],
          data: {
            api: "/dept/get-tree/",
            url_type: "tree",
            args: null,
            table: "mrbase_sys_org_levels",
            type: "",
            modelKey: "org_level_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          showKey: "job_post_name",
          name: "job",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobLabel",
          value: [],
          selected: [],
          data: {
            api: "/job-post/get-list/",
            url_type: "primary",
            args: { dept_uuid: "" },
            table: "mrbase_sys_job_posts",
            type: "",
            modelKey: "job_post_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getStaff();
  },

  watch: {
    selectOneStaff(val) {
      const that = this;
      this.$Sleep(600).then(() => {
        if (val) {
          that.selectItem = that.show_Staff.find(
            (ele) => ele.staff_uuid.toString() === val.toString()
          );
          that.getDetail(val);
        } else {
          that.desserts = [];
        }
      });
    },
    curDept(val) {
      //监听部门变化
      this.$fliterValue(this.filterObjects, "job", []);
      if (!val || val.length == 0) {
        this.filterObjects[2]["disabled"] = true;
      }
      if (val) {
        let arr = [];
        if (val.length) {
          this.filterObjects[2]["disabled"] = false;
          val.map((e) => {
            if (e && e.uuid) arr.push(e.uuid);
          });
          this.filterObjects[2]["data"]["args"]["dept_uuid"] = arr.join(",");
        } else {
          return;
        }
      }
    },
  },
  methods: {
    toFilter(callback) {
      const that = this;
      this.desserts = [];
      this.selectOneStaff = null;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "staff")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "job")
          data["job_post_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "department") {
          let arr = [];
          if (item.value.length) {
            item.value.map((e) => {
              e && e.uuid ? arr.push(e.uuid) : null;
            });
          }
          data["dept_uuid"] = arr.join(",");
        }
      });
      this.getStaff(data);
    },
    toEdit: function (item, triger) {
      this.triger = triger;
      this.curUuid = item.staff_uuid;
      this.curName = item.preferred_name;
      this.showEdit = true;
    },
    onSave: function (obj, delete_ids) {
      const that = this;
      let arr = [];
      that.showEdit = false;

      obj.map((item) => {
        let json = {};
        if (item.uuid) json["uuid"] = item.uuid;
        json["staff_uuid"] = item.staff_uuid;
        json["staff_card_code"] = item.staff_card_code;
        json["effective_utc_start_date"] = that.$getTimeValue(
          item.effective_utc_start_date
        );
        json["effective_start_time_zone"] = item.effective_start_time_zone;
        json["remarks"] = item.remarks;
        json["source"] = item.source;
        arr.push(json);
      });
      this.$Request({
        method: "POST",
        table: "ess_punch_map_staff_punch_card_number",
        url: "/staff-card/update/",
        data: {
          delete_ids: delete_ids.join(","),
          ess_punch_map_staff_punch_card_number: arr,
        },
      }).then((res) => {
        that.showEdit = false;
        that.getDetail(that.selectOneStaff);
        that.curUuid = null;
        that.curName = "";
        that.$showMessage({
          color: "success",
          text: that.$t(
            "message_essweb_StaffCard_list_updateStaffCardSuccessLabel"
          ),
          type: "success",
        });
      });
    },
    getDetail: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_punch_map_staff_punch_card_number",
        url: "/staff-card/get-details/",
        data: { staff_uuid: uuid },
      }).then((res) => {
        res.data.map((item) => {
          item["effective_utc_start_date"] = that.$getDateTime(
            item.effective_utc_start_date,
            "YYYY-MM-DD"
          );
          item["effective_utc_start_date_save"] = that.$getDateTime(
            item.effective_utc_start_date,
            "YYYY-MM-DD"
          );
        });
        that.desserts = res.data;
      });
    },
    getStaff: function (filter) {
      const that = this;
      this.staff_Loading = true;
      let data = Object.assign({}, filter ? filter : {});
      this.$Request({
        method: "POST",
        table: "ess_punch_map_staff_punch_card_number",
        url: "/staff-card/get-list/",
        data: data,
      }).then((res) => {
        that.allStaff = res.data;
        this.show_Staff = res.data;
        this.staff_Loading = false;
        // that.totalCount = res.totalcount;
        // callback ? callback() : null;
      });
    },
  },
};
</script>


